// eslint-disable-next-line jira/restricted/relay-runtime
import { Environment } from 'relay-runtime';
import { getRelayEnvironmentConfig } from '@atlassian/jira-relay-environment-config/src/index.tsx';

let relayEnvironment: Environment;

export default function getRelayEnvironment() {
	if (!relayEnvironment) {
		const environmentConfig = getRelayEnvironmentConfig();
		relayEnvironment = new Environment(environmentConfig);
	}
	return relayEnvironment;
}
